import { Dialog } from 'vant'
import {
    Error
} from '@/components/customPromotion'
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import { GoodsList, ServerList } from '@/components/aggregation'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import {
    getAggregationInfo,
    getAggregationList
} from '@/models/aggregation'
import { wxShare } from '@/utils/wxsdk'

export default {
    name: viewName.aggregation,
    components: {
        Error,
        GoodsList,
        ServerList,
        swiper,
        swiperSlide
    },
    data () {
        return {
            top_img: '',
            pageStatus: true,
            sstore_id: '',
            topic_id: '',
            vehicle_id: '',
            sms_id: '',
            carDetail: '',
            storeInfo: {},
            currentTab: 0, // 现在用户选择的tab 1.商品2.服务 首次默认取优先级高的tab，但是如果优先级高的tab没有数据而低的有则取优先级低的tab
            tabs_sort: [], // 优先级
            goods: [],
            server: [],
            banner: [],
            swiperOption: {
                direction: 'horizontal',
                loop: false,
                autoplay: true,
                slidesPerView: 'auto',
                centeredSlides: true,
                duration: 3000,
                spaceBetween: 15,
                pagination: {
                    el: '.swiper-pagination',
                    bulletActiveClass: 'slide_dot_active',
                    bulletClass: 'slide_dot'
                },
                on: {
                    click: (v) => { // 当loop：true时，swiper从第一张直接划到最后一次，img里面添加的事件会不执行，故在此做处理
                        let item = {
                            link: v.target.getAttribute('data-link'),
                        }
                        this.pptJump(item)
                    }
                }
            }
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        })
    },
    async created () {
        this.carDetail = this.$route.query.carDetail || ''
        this.sms_id = this.$route.query.sms_id || ''
        this.vehicle_id = this.$route.query.vehicle_id
        this.topic_id = this.$route.query.topic_id
        this.sstore_id = this.$route.query.sstore_id
        if (!this.topic_id) {
            this.pageStatus = false
            Dialog.alert({
                message: '页面缺少参数'
            })
            return
        }
        this.showLoading()
        try {
            let par = this.sstore_id ? {
                topic_id: this.topic_id,
                sstore_id: this.sstore_id,
                sms_id: this.sms_id
            } : {
                topic_id: this.topic_id,
                sms_id: this.sms_id
            }
            const res = await getAggregationInfo(par)
            this.$emit('setHeader', {
                title: res.share.title,
                showHeader: true,
                showLeft: false
            })
            this.top_img = res.top_img
            this.tabs_sort = res.tabs_sort
            this.currentTab = this.tabs_sort.length ? Number(this.tabs_sort[0]) : 0
            this.storeInfo = res.sstore
            this.banner = res.banners
            if (this.banner && this.banner.length > 2) {
                this.swiperOption.loop = true
            }
            this.configWxShare(res.share)
            this.$store.commit('SET_CURRENT_TAB', this.currentTab)
            this.$store.commit('SET_TOPIC_ID', this.topic_id)
            this.$store.commit('SET_SSTORE_ID', this.sstore_id)
            this.$store.commit('SET_SMS_ID', this.sms_id)
            this.$store.commit('SET_VEHICLE_ID', this.vehicle_id)
            localStorage.setItem('TOPICID', this.topic_id) // 因为怕测试在搜索页刷新导致vuex状态丢失，决定做本地缓存，所以上面的vuex其实可以不用
            localStorage.setItem('SSTOREID', this.sstore_id)
            localStorage.setItem('AGGREGATIONCURRENTTAB', this.currentTab)
            localStorage.setItem('SMSID', this.sms_id)
            localStorage.setItem('VEHICLEID', this.vehicle_id)
            if (!this.currentTab) {
                return
            }
            this.getList()
        } catch (e) {

        } finally {
            this.hideLoading()
        }
    },
    activated () {

    },
    mounted () {

    },
    inject: ['showLoading', 'hideLoading'],
    methods: {
        ...mapActions([
            'setAppClass'
        ]),
        pptJump (item) {
            if (!item.link) {
                return
            }
            window.location.href = item.link
        },
        goToServer (item) {
            this.$router.push({
                path: '/serviceDetail',
                query: {
                    sstore_id: this.sstore_id,
                    service_id: item.server_id,
                    sms_id: this.sms_id
                    // showBuy: true
                }
            })
        },
        goToGoods (item) {
            this.$router.push({
                path: '/goodsDetail',
                query: {
                    sstore_id: this.sstore_id,
                    goods_type: item.goods_type,
                    spu_id: item.spu_id,
                    spec_id: item.spec_id,
                    sms_id: this.sms_id
                }
            })
        },
        async getList () {
            this.showLoading()
            const res = await getAggregationList({
                topic_id: this.topic_id,
                sstore_id: this.sstore_id,
                topic_type: this.currentTab
            })
            this.hideLoading()
            this.currentTab === 2 ? this.server = res : this.goods = res
        },
        changeTab (value) {
            if (this.currentTab === value) {
                return
            }
            this.$store.commit('SET_CURRENT_TAB', value)
            this.currentTab = value
            this.getList()
        },
        onCallPhone () {
            const { sstore_phone } = this.storeInfo
            window.location.href = 'tel://' + sstore_phone
        },
        onGoStore () {
            const { latitude, longitude, sstore_name, sstore_address } = this.storeInfo
            window.location.href = `https://api.map.baidu.com/marker?location=${latitude},${longitude}&title=${sstore_name}&content=${sstore_address}&output=html&src=webapp.baidu.openAPIdemo`
        },
        lookMore () {
            this.$router.push({
                path: '/aggregationSearch',
                query: {
                    carDetail: this.carDetail,
                    vehicle_id: this.vehicle_id,
                    sstore_id: this.sstore_id,
                    topic_id: this.topic_id,
                    currentTab: this.currentTab,
                    sms_id: this.sms_id
                }
            })
        },
        configWxShare (item) {
            if (this.isWeixin) {
                const params = {
                    title: item.title,
                    desc: item.share_content,
                    imgUrl: item.imgUrl,
                    link: location.href
                }
                wxShare(params)
            }
        }
    },
    destroyed () {

    },
}
